import AdminProducts from '../admin/AdminProducts';
import EmployeeLayout from './EmployeeLayout';

export default function EmployeeProducts() {
  return <AdminProducts Layout={EmployeeLayout} />;
}
